import Component from '@bythepixel/component-loader';
import { DEFAULTS, STATES } from '@Front/components/modal/_config';
import { handleComponentError } from '@Core/helpers/functions';

export default class Modal extends Component {
  static selector = `[${DEFAULTS.modal}]`;

  constructor(containerEl, options = { ...DEFAULTS, ...STATES }) {
    super(containerEl, options);

    this.modal = this.$container;
    this.triggers = document.querySelectorAll(`[${this.$options.trigger}="${this.modal.id}"]`);
    this.closers = this.$container.querySelectorAll(`[${this.$options.closer}="${this.modal.id}"]`);

    this.mount();
  }

  mount() {
    handleComponentError([
      [this.closers.length === 0, 'Modal element needs at least 1 closing button.'],
      [this.triggers.length === 0, 'Modal element needs at least 1 trigger button.'],
      [this.modal.tagName !== 'DIALOG', 'Modal has incorrect tag. It must be a DIALOG element.'],
    ]);

    this.registerTriggers();
    this.registerClosers();
    this.registerModalCancel();
    this.registerAnimationHandler();
  }

  registerTriggers() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        this.openModal();
      });
    });
  }

  registerClosers() {
    this.closers.forEach((closer) => {
      closer.addEventListener('click', () => {
        this.closeModal();
      });
    });

    this.modal.addEventListener('click', (event) => {
      if (event.target === this.modal) {
        this.closeModal();
      }
    });
  }

  registerModalCancel() {
    this.modal.addEventListener('cancel', (event) => {
      event.preventDefault();
      this.closeModal();
    });
  }

  registerAnimationHandler() {
    this.modal.addEventListener('animationend', (event) => {
      if (event.animationName !== this.$options.animation) {
        return;
      }

      switch (this.modal.getAttribute(this.$options.state)) {
      case 'opening':
        this.modal.setAttribute(this.$options.state, this.$options.opened);
        break;
      default:
        this.modal.setAttribute(this.$options.state, this.$options.closed);
        this.modal.close();
      }
    });
  }

  pauseAllMedia() {
    this.modal.querySelectorAll('video').forEach((video) => {
      video.pause();
    });
  }

  openModal() {
    this.modal.setAttribute(this.$options.state, this.$options.opening);
    this.modal.showModal();
  }

  closeModal() {
    this.modal.setAttribute(this.$options.state, this.$options.closing);
    this.pauseAllMedia();
  }
}
